import { combineReducers } from "redux";
import authReducer from "@/screens/auth/authSlice";
import deliveryReducer from "@/screens/delivery/deliverySlice";
import historyReducer from "@/screens/history/historySlice";
import reportReducer from "@/screens/report/reportSlice";
import routeDetailsReducer from "@/screens/route-details/routeDetailsSlice";
import settingReducer from "@/screens/setting/settingSlice";
import optimiseRoutesReducer from "@/screens/optimise-routes/optimiseRoutesSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  delivery: deliveryReducer,
  history: historyReducer,
  report: reportReducer,
  routeDetails: routeDetailsReducer,
  settings: settingReducer,
  optimiseRoutes: optimiseRoutesReducer,
});

export default rootReducer;